module.exports = "/assets/data/6cefac563f4e4a9eb426a0d8e1be67cd-CB8.data.json";